import { Alert, Button, Modal, Popconfirm, Tooltip, Dropdown, message, Upload, Select } from "antd";
import type { UploadFile } from 'antd/es/upload/interface';
import React, { useEffect, useState } from 'react';
import "./styles.scss";
import { mixGetV1 } from "services/mixin";
import { CloudUploadOutlined, DeleteOutlined, DownloadOutlined, FileExcelOutlined } from '@ant-design/icons';
import type { UploadProps } from 'antd';
import { EditAccount } from "./credentialsModal";
import { API_URL, API_URL_v2 } from "env";
import Marquee from 'react-fast-marquee';
import axios from 'axios';
import TelegramButton from "./TelegramButton";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Import các API Bot
import { BotCreateParams, BotLogData, BotStatusData } from "pages/Dashboard/BotPannel/function/type";
import { deleteDockerContainer, getDockerContainerLogs, getDockerContainerStatus, saveTradeAccountCredentials, stopDockerContainer } from "pages/Dashboard/BotPannel/function/api";
import { BotCreateModal } from "pages/Dashboard/BotPannel/component/BotCreate";
import { BotStatusModal } from "pages/Dashboard/BotPannel/component/BotStatus";
import i18n from "lang/i18n";
import { useAppNotification } from "hooks/useNotification";

// Import các Component Bot & Type

const { Dragger } = Upload;

interface AccountInfoProps {
    idAccount: number;
    accountId: string;
    initial_balance: number;
    current_balance_formatted: string;
    current_equity_formatted: string;
    current_pnl_formatted: string;
    todays_profit_formatted: string;
    current_equity: number;
    current_balance: number;
    current_pnl: number;
    todays_profit: number;
    created_at: string;
    index: number;
    status: "active" | "inactive" | "suspended";
    accountType: "admin" | "user" | "guest";
    accountLevel: "basic" | "premium" | "enterprise";
    endDate: Date;
    loginCredentials: {
        loginID: string;
        masterPassword: string;
        readOnlyPassword: string;
    };
    perfomance: {
        profit: number;
        Equity: number;
        PnL: number;
    };
    platform?: string;
    user?: {
        userId: string;
        userName: string;
        broker: string;
    };
    currency?: string;
    visible?: boolean;
    disableVisible?: boolean;
    onUpdate?: () => void;
    setVisible?: (value: boolean) => void;
    setIsShowModalCredentials?: (value: boolean, accountId: string) => void;
    deleteAccount: (id: number, platform: string, account_number: string) => void;
    onQuickView?: () => void;
}

const VALID_ACCOUNT_TYPES = ['challenge', 'verification', 'funded', 'demo'];

interface listDataProp {
    login_id: string;
    extra_id: string;
    equity: string;
    balance: string;
    profit: string;
    time: string;
    orders: any;
    positions: any;
    alarm: {
        positions: {
            position_id: string;
            msg: string;
            volume: string;
            reason: string;
        }[];
        orders: {
            order_id: string;
            msg: string;
            volume: string;
            reason: string;
        }[];
    };
    net_profit_today?: string;
}

const AccountDetail: React.FC<AccountInfoProps> = ({
    idAccount,
    accountId,
    initial_balance,
    current_balance_formatted,
    current_equity_formatted,
    current_pnl_formatted,
    todays_profit_formatted,
    current_equity,
    current_balance,
    current_pnl,
    todays_profit,
    created_at,
    status,
    index,
    accountType,
    accountLevel,
    currency,
    endDate,
    perfomance,
    loginCredentials,
    platform,
    user,
    visible,
    disableVisible,
    onUpdate,
    setVisible,
    setIsShowModalCredentials,
    deleteAccount,
    onQuickView,
}) => {
    const [listData, setListData] = useState<listDataProp>({
        login_id: "",
        extra_id: "",
        equity: "",
        balance: "",
        profit: "",
        time: "",
        orders: [],
        positions: [],
        alarm: { positions: [], orders: [] },
    });

    const [openModal, setOpenModal] = useState(false);
    const [selectModalOption, setSelectModalOption] = useState<string>('MT5');
    const [editModal, setEditModal] = useState(false);
    const [file, setFile] = useState<UploadFile | null>(null);
    const [isImport, setIsImport] = useState<boolean>(false);
    const { t } = useTranslation();
    const { language } = i18n;
    const notification = useAppNotification();
    // --- STATE QUẢN LÝ BOT ---
    const [isOpenBotCreate, setIsOpenBotCreate] = useState(false);
    const [isOpenBotStatus, setIsOpenBotStatus] = useState(false);
    const [botStatusData, setBotStatusData] = useState<BotStatusData | null>(null);
    const [loadingBot, setLoadingBot] = useState(false);
    function formatDateTime(input: string): string {
        const date = new Date(input);
        const day = date.getDate().toString().padStart(2, '0');
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        if (language === 'vi') {
            return `${day}/${month}/${year}`;
        }
        return `${day} ${monthNames[date.getMonth()]} ${year}`;
    }

    // --- HÀM XỬ LÝ MỞ BOT / KIỂM TRA TRẠNG THÁI BOT ---
    const handleOpenBot = async () => {
        setLoadingBot(true);
        const currentPlatform = platform || 'mt5';
        try {
            const botData = await getDockerContainerStatus(currentPlatform, accountId);
            if (botData && botData.container && botData.status) {
                setBotStatusData(botData as BotStatusData);
                setIsOpenBotStatus(true);
            } else {
                setIsOpenBotCreate(true);
            }
        } catch (error) {
            console.error('Không thể lấy thông tin bot:', error);
            // Mặc định mở modal tạo mới nếu chưa tồn tại bot
            setIsOpenBotCreate(true);
        } finally {
            setLoadingBot(false);
        }
    };

    // --- XỬ LÝ TẠO BOT MỚI ---
    const handleCreateBotSubmit = async (data: BotCreateParams) => {
        const currentPlatform = data.platform || platform || 'mt5';
        try {
            await saveTradeAccountCredentials(data.account_number, {
                account: data.account_number,
                password: data.password || '',
                server: data.server_name || '',
                platform: currentPlatform,
                ctraderId: data.ctrader_id || '',
            });
            notification.success('Bot created successfully');
            setIsOpenBotCreate(false);
        } catch (error) {
            console.error('Error creating bot:', error);
            notification.error('There was an error creating the bot');
        }
    };

    const handleFetchLogs = async (account: string): Promise<BotLogData> => {
        const currentPlatform = platform || 'mt5';
        const res = await getDockerContainerLogs(currentPlatform, account, 50);

        let content = '';
        if (res?.logs) {
            if (typeof res.logs === 'string') {
                content = res.logs;
            } else if ('content' in res.logs && typeof res.logs.content === 'string') {
                content = res.logs.content;
            }
        }

        return {
            platform: currentPlatform,
            account: account,
            tail: 50,
            logs: {
                container: account,
                content: content || 'Không tìm thấy dữ liệu log.',
            },
        };
    };

    const propsUpload: UploadProps = {
        name: 'file',
        multiple: false,
        action: '',
        onChange(info) {
            const { status } = info.file;
            if (status === 'done') {
                message.success(`${info.file.name} file uploaded successfully.`);
            } else if (status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        },
    };

    async function onEditAccount({ accountId, nickName, balanceSize, platform, broker, accountType }: { accountId: number, nickName: string, balanceSize: number, platform: string, broker: string, accountType?: string }) {
        try {
            if (!accountId || !nickName || !platform || !broker) {
                notification.error('Please fill all fields');
                return;
            }
            const updateInfo = await fetch(API_URL + `/api/v1/be/trade_account/${accountId}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
                body: JSON.stringify({
                    nickname: nickName,
                    balance: balanceSize,
                    platform: platform,
                    broker: broker,
                    // Only send a real status; placeholders like "No status" must not overwrite the account
                    ...(accountType && VALID_ACCOUNT_TYPES.includes(accountType) && { account_status: accountType })
                }),
            });
            if (updateInfo.ok) {
                notification.success('Updated account information successfully.');
            } else {
                notification.error('There is an error at lumir service !');
            }
        } catch (error) {
            console.error('Error updating account:', error);
            notification.error('There was an error updating the account');
        } finally {
            if (onUpdate) {
                onUpdate();
            }
        }
    }

    const tradeHistoryImport = async (): Promise<void> => {
        setIsImport(true);
        if (!file || accountId === null) {
            message.error('Vui lòng chọn file và nhập mã tài khoản.');
            setIsImport(false);
            return;
        }

        const authToken = localStorage.getItem('token');
        if (!authToken) {
            message.error('Không tìm thấy token xác thực.');
            setIsImport(false);
            return;
        }

        const formData = new FormData();
        if (file.originFileObj) {
            formData.append('excel_file', file.originFileObj);
        } else {
            message.error('Invalid file');
            setIsImport(false);
            return;
        }
        formData.append('account_number', accountId);

        try {
            await axios.post(`${API_URL}/api/v1/be/trade-history/import`, formData, {
                headers: { Authorization: `Bearer ${authToken}` },
            });
            setOpenModal(false);
            message.success('File đã được upload thành công.');
        } catch (error) {
            console.error('Lỗi khi upload file:', error);
            message.error('Có lỗi xảy ra khi upload file.');
        } finally {
            setIsImport(false);
        }
    };

    return (
        <div className="flex flex-col">
            {listData?.alarm && listData?.alarm?.positions?.length > 0 && (
                <Alert
                    message={
                        <Marquee speed={20} pauseOnHover gradient={false}>
                            {listData.alarm.positions.map((item, idx) => (
                                <span key={idx} className="text-content-secondary text-body-medium">
                                    <span className="text-content-primary px-1">
                                        {item.msg} - {t('volume')}: {item.volume}
                                    </span>
                                </span>
                            ))}
                        </Marquee>
                    }
                    type="warning"
                    showIcon
                    className="w-full text-content-secondary text-body-medium !m-0 border-none !rounded-b-none mb-2"
                />
            )}

            {/* Modal Import Trade History */}
            <Modal
                style={{ top: '5vh', maxHeight: '90vh' }}
                title={<span className="text-lg font-semibold">{t('ImportTradeHistory')} - {accountId}</span>}
                width={600}
                open={openModal}
                onOk={() => { if (!isImport) setOpenModal(false); }}
                onCancel={() => { if (!isImport) setOpenModal(false); }}
                closable={!isImport}
                maskClosable={!isImport}
                footer={[
                    <Button key="cancel" size="large" onClick={() => { if (!isImport) setOpenModal(false); }}>
                        Cancel
                    </Button>,
                    <Button
                        key="submit"
                        size="large"
                        type="primary"
                        icon={<CloudUploadOutlined />}
                        disabled={!file || !selectModalOption}
                        onClick={tradeHistoryImport}
                    >
                        <span>{t('ImportData')}</span>
                    </Button>,
                ]}
            >
                {/* Nội dung Modal Import */}
                <div className="flex flex-col overflow-y-auto max-h-[620px]">
                    <p className="text-sm font-semibold mb-1">{t('SelectTradingPlatform')}</p>
                    <Select
                        className="w-full mb-3"
                        size="large"
                        value={selectModalOption}
                        onChange={(value) => setSelectModalOption(value)}
                        options={[
                            { value: 'MT5', label: 'MT5' },
                            { value: 'MT4', label: 'MT4' },
                            { value: 'cTrader', label: 'cTrader' },
                            { value: 'TradingView', label: 'TradingView' }
                        ]}
                    />
                    <Dragger
                        {...propsUpload}
                        maxCount={1}
                        accept=".xlsx, .xls, .csv"
                        beforeUpload={(rcFile) => {
                            setFile({
                                uid: Math.random().toString(36).substring(7),
                                name: rcFile.name,
                                originFileObj: rcFile,
                            });
                            return false;
                        }}
                        onRemove={() => setFile(null)}
                        fileList={file ? [file] : []}
                    >
                        <p className="ant-upload-drag-icon"><CloudUploadOutlined /></p>
                        <p className="ant-upload-text">{t('uploadText')}</p>
                    </Dragger>
                </div>
            </Modal>

            {/* Thẻ chính AccountDetail */}
            <div
                className="acct-card"
                style={{
                    background: 'var(--card-bg)',
                    border: '1px solid var(--card-border)',
                    borderRadius: '12px',
                    padding: '18px 20px',
                    position: 'relative',
                    boxShadow: '0 1px 2px rgba(16,24,40,0.03)',
                    transition: 'box-shadow .15s, border-color .15s',
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '14px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '11px', minWidth: 0 }}>
                        <div
                            style={{
                                width: '36px',
                                height: '36px',
                                borderRadius: '50%',
                                background: '#eef0f4',
                                color: '#5a6478',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontWeight: 700,
                                fontSize: '13px',
                                flexShrink: 0
                            }}
                        >
                            {(user?.userName || 'T')?.[0]?.toUpperCase()}
                        </div>
                        <div style={{ minWidth: 0 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '7px', flexWrap: 'wrap' }}>
                                <span style={{ fontWeight: 700, fontSize: '14px', color: 'var(--text-title)' }}>
                                    {user?.userName || 'Trader'}
                                </span>
                                <span
                                    style={{
                                        background: '#e6f7f4',
                                        color: '#0f766e',
                                        fontSize: '10px',
                                        fontWeight: 700,
                                        padding: '2px 6px',
                                        borderRadius: '5px'
                                    }}
                                >
                                    #{platform?.toUpperCase()}
                                </span>
                            </div>
                            <div className="om-num" style={{ fontSize: '12px', color: 'var(--text-desc)', marginTop: '2px' }}>
                                Login {accountId}
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
                        {!disableVisible && (
                            <div
                                onClick={() => setVisible?.(!visible)}
                                style={{
                                    width: '36px',
                                    height: '21px',
                                    borderRadius: '11px',
                                    background: visible ? '#f2a93b' : '#dfe3ea',
                                    position: 'relative',
                                    cursor: 'pointer',
                                }}
                            >
                                <div
                                    style={{
                                        width: '17px',
                                        height: '17px',
                                        borderRadius: '50%',
                                        background: '#fff',
                                        position: 'absolute',
                                        top: '2px',
                                        left: visible ? '17px' : '2px',
                                        transition: 'left .15s',
                                    }}
                                />
                            </div>
                        )}

                        {/* Menu Dropdown Thao Tác */}
                        <Dropdown
                            menu={{
                                items: [
                                    {
                                        key: 'bot',
                                        label: (
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <rect x="4" y="9" width="16" height="10" rx="2"></rect>
                                                    <circle cx="9" cy="14" r="1"></circle>
                                                    <circle cx="15" cy="14" r="1"></circle>
                                                    <path d="M9 9V5a3 3 0 0 1 6 0v4"></path>
                                                </svg>
                                                {loadingBot ? 'Đang kiểm tra Bot...' : t('connect_bot')}
                                            </div>
                                        ),
                                        onClick: handleOpenBot
                                    },
                                    {
                                        key: 'import-data',
                                        label: (
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                                    <polyline points="7 10 12 15 17 10"></polyline>
                                                    <line x1="12" y1="15" x2="12" y2="3"></line>
                                                </svg>
                                                {t('ImportTradeHistory')}
                                            </div>
                                        ),
                                        onClick: () => setOpenModal(true)
                                    },
                                    {
                                        key: 'edit',
                                        label: (
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <path d="M12 20h9"></path>
                                                    <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"></path>
                                                </svg>
                                                {t('EditAccount')}
                                            </div>
                                        ),
                                        onClick: () => setEditModal(true)
                                    },
                                    { type: 'divider' },
                                    {
                                        key: 'delete',
                                        danger: true,
                                        label: (
                                            <Popconfirm
                                                title={t('delete_account_confirm_title')}
                                                description={t('delete_account_confirm_message')}
                                                onConfirm={() => deleteAccount(idAccount, platform || 'unknown', accountId)}
                                                okText={t('jd_yes')}
                                                cancelText={t('jd_no')}
                                            >
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M3 6h18"></path>
                                                        <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                                        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
                                                        <path d="M10 11v6M14 11v6"></path>
                                                    </svg>
                                                    {t('DeleteAccount')}
                                                </div>
                                            </Popconfirm>
                                        )
                                    }
                                ]
                            }}
                            trigger={['click']}
                        >
                            <button
                                style={{
                                    width: '28px',
                                    height: '28px',
                                    borderRadius: '7px',
                                    border: '1px solid var(--card-border)',
                                    background: 'var(--card-bg)',
                                    color: 'var(--text-desc)',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
                                    <circle cx="5" cy="12" r="1.8"></circle>
                                    <circle cx="12" cy="12" r="1.8"></circle>
                                    <circle cx="19" cy="12" r="1.8"></circle>
                                </svg>
                            </button>
                        </Dropdown>
                    </div>
                </div>
                {
                    visible && (
                        <>
                            <div className="acct-card__meta" style={{ fontSize: '13px', color: 'var(--text-desc)', marginBottom: '14px' }}>
                                <span className="om-num">
                                    {t('accountQuickView.initialBalance')}: <b style={{ color: 'var(--text-title)' }}>
                                        {initial_balance ? initial_balance.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' USD' : '—'}
                                    </b>
                                </span>
                                <span style={{ color: 'var(--card-border)', margin: '0 8px' }}>|</span>
                                <span>{t('Start')}: <b style={{ color: 'var(--text-title)' }}>{formatDateTime(created_at)}</b></span>
                                <span style={{ color: 'var(--card-border)', margin: '0 8px' }}>|</span>
                                <span>{t('Status')}: <b style={{ color: 'var(--stat-green-text)' }}>{status === 'active' ? t('Active') : t('Inactive')}</b></span>
                            </div>

                            <div className="acct-card__divider" style={{ height: '1px', background: 'var(--bg-divider)', marginBottom: '14px' }} />

                            <div className="acct-card__actions" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px', marginBottom: '16px' }}>
                                <div className="acct-card__links" style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
                                    {onQuickView && (
                                        <button
                                            type="button"
                                            onClick={onQuickView}
                                            style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '12.5px', fontWeight: 700, color: 'var(--stat-teal-text)', background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
                                        >
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                                            {t('accountQuickView.quickView')}
                                        </button>
                                    )}
                                    <Link to={`/academy?tab=checklist`} style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '12.5px', fontWeight: 600, color: 'var(--text-title)', textDecoration: 'none' }}>
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 3v18h18"></path><path d="M18 17V9M13 17V5M8 17v-3"></path></svg>
                                        {t('BehavioralPerformance')}
                                    </Link>
                                    <Link to={`/${platform}/account-metrix/${accountId}`} style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '12.5px', fontWeight: 600, color: 'var(--text-title)', textDecoration: 'none' }}>
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="m3 17 6-6 4 4 8-8"></path><path d="M14 6h7v7"></path></svg>
                                        {t('MetriX')}
                                    </Link>
                                    <Link to={`/${platform}/account-live-metrix/${accountId}`} style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '12.5px', fontWeight: 600, color: 'var(--text-title)', textDecoration: 'none' }}>
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><path d="M14 2v6h6"></path><path d="M9 13h6M9 17h6"></path></svg>
                                        {t('LiveMetrix')}
                                    </Link>
                                </div>

                                {/* NÚT KẾT NỐI BOT TRÊN GIAO DIỆN */}
                                <button
                                    onClick={handleOpenBot}
                                    disabled={loadingBot}
                                    className="acct-card__bot"
                                    title={t('connect_bot')}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        background: 'var(--card-bg)',
                                        border: '1px solid var(--card-border)',
                                        borderRadius: '8px',
                                        padding: '7px 13px',
                                        fontSize: '12.5px',
                                        fontWeight: 700,
                                        color: 'var(--text-desc)',
                                        cursor: 'pointer',
                                        whiteSpace: 'nowrap',
                                        opacity: loadingBot ? 0.6 : 1
                                    }}
                                >
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <rect x="4" y="9" width="16" height="10" rx="2"></rect>
                                        <circle cx="9" cy="14" r="1"></circle>
                                        <circle cx="15" cy="14" r="1"></circle>
                                        <path d="M9 9V5a3 3 0 0 1 6 0v4"></path>
                                    </svg>
                                    <span className="acct-card__bot-label">{loadingBot ? 'Đang kiểm tra...' : t('connect_bot')}</span>
                                </button>
                            </div>

                            <div className="acct-card__stats" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px' }}>
                                <div className="acct-card__tile" style={{ background: Number(todays_profit) < 0 ? 'var(--stat-red-bg)' : Number(todays_profit) > 0 ? 'var(--stat-green-bg)' : 'var(--stat-yellow-bg)', borderRadius: '9px', padding: '10px 12px' }}>
                                    <div className="acct-card__tile-label" style={{ fontSize: '11px', color: 'var(--text-desc)', fontWeight: 600, marginBottom: '5px' }}>{t('Todayprofit')}</div>
                                    <div className="om-num" style={{ fontWeight: 700, fontSize: '13px', color: Number(todays_profit) < 0 ? 'var(--stat-red-text)' : Number(todays_profit) > 0 ? 'var(--stat-green-text)' : 'var(--stat-yellow-text)' }}>
                                        {todays_profit_formatted || '$0.00'}
                                    </div>
                                </div>
                                <div className="acct-card__tile" style={{ background: 'var(--stat-teal-bg)', borderRadius: '9px', padding: '10px 12px' }}>
                                    <div className="acct-card__tile-label" style={{ fontSize: '11px', color: 'var(--text-desc)', fontWeight: 600, marginBottom: '5px' }}>{t('Balance')}</div>
                                    <div className="om-num" style={{ fontWeight: 700, fontSize: '13px', color: 'var(--stat-teal-text)' }}>
                                        {current_balance_formatted ? current_balance_formatted : (listData?.balance ? parseFloat(listData.balance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 'N/A') || '$0.00'}
                                    </div>
                                </div>
                                <div
                                    className="acct-card__tile"
                                    style={{
                                        background: Number(current_pnl) < 0 ? 'var(--stat-red-bg)' : Number(current_pnl) > 0 ? 'var(--stat-green-bg)' : 'var(--stat-yellow-bg)',
                                        borderRadius: '9px',
                                        padding: '10px 12px'
                                    }}
                                >
                                    <div className="acct-card__tile-label" style={{ fontSize: '11px', color: 'var(--text-desc)', fontWeight: 600, marginBottom: '5px' }}>{t('UnrealizedPnL')}</div>
                                    <div
                                        className="om-num"
                                        style={{
                                            fontWeight: 700,
                                            fontSize: '13px',
                                            color: Number(current_pnl) < 0 ? 'var(--stat-red-text)' : Number(current_pnl) > 0 ? 'var(--stat-green-text)' : 'var(--stat-yellow-text)'
                                        }}
                                    >
                                        {current_pnl_formatted || '$0.00'}
                                    </div>
                                </div>
                            </div>
                        </>
                    )
                }



                {/* Modal Chỉnh Sửa Tài Khoản */}
                <Modal
                    title={`${t('EditAccount')} ${accountId}`}
                    open={editModal}
                    onOk={() => setEditModal(false)}
                    onCancel={() => setEditModal(false)}
                    width={600}
                    footer={null}
                    zIndex={1000}
                >
                    <EditAccount
                        onClose={() => setEditModal(false)}
                        onSave={(value) => {
                            const { accountId, nickName, balanceSize, platform, broker, accountType } = value;
                            onEditAccount({ accountId, nickName, balanceSize, platform, broker, accountType });
                            setEditModal(false);
                        }}
                        account={{
                            accountId: idAccount,
                            account_number: accountId,
                            nickName: user?.userName || "Unknown User",
                            balanceSize: initial_balance || 0,
                            platform: platform || "Unknown Platform",
                            broker: user?.broker || "Unknown Broker",
                            accountType: accountType || "Unknown Account Type"
                        }}
                    />
                </Modal>

                {/* --- COMPONENT MODAL TẠO BOT MỚI --- */}
                <BotCreateModal
                    isOpen={isOpenBotCreate}
                    onClose={() => setIsOpenBotCreate(false)}
                    onSubmit={handleCreateBotSubmit}
                    account_number={accountId}
                    platform={platform}
                />

                {/* --- COMPONENT MODAL XEM TRẠNG THÁI & ĐIỀU KHIỂN BOT --- */}
                {botStatusData && (
                    <BotStatusModal
                        isOpen={isOpenBotStatus}
                        onClose={() => setIsOpenBotStatus(false)}
                        data={botStatusData}
                        onFetchLogs={handleFetchLogs}
                    />
                )}
            </div>
        </div>
    );
};

export default AccountDetail;